@if(score()) {
  <div class="circular">
    <div class="inner"></div>
    <div class="number">{{ score() }}%</div>
    <div class="circle">
      <div class="bar left">
        <div
          class="progress"
          [ngStyle]="{ transform: 'rotate(' + this.leftDegrees() + 'deg)' }"
        ></div>
      </div>
      <div class="bar right">
        <div
          class="progress"
          [ngStyle]="{ transform: 'rotate(' + this.rightDegrees() + 'deg)' }"
        ></div>
      </div>
    </div>
  </div>
}

